import request from 'utils/request'

// 用户退出登录
export const logout = () => request().get('logout')

// 用户修改密码
export const modifyPassword = data =>
  request().post('user/password/modify', data)
